import { useEffect, useState } from "react";

import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { setDirectEditAllowed } from "./orderLock";

/**
 * Asks once whether this user edits locked orders directly (super admin, or
 * one of the two fixed approvers) and shares the answer with orderLock, which
 * the listings call per row. Returns the flag so the caller re-renders.
 */
function useOrderChangeAccess() {
  const [canEditLocked, setCanEditLocked] = useState(false);
  const { postData: fetchAccess } = usePostRequest(API_ENDPOINTS.CHANGE_REQUEST_ACCESS);

  useEffect(() => {
    fetchAccess({}, (res) => {
      const allowed = Boolean(res?.data?.can_edit_locked_orders);
      setDirectEditAllowed(allowed);
      setCanEditLocked(allowed);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return canEditLocked;
}

export default useOrderChangeAccess;
